<template>
  <div class="p-4">
    <h1 class="text-2xl font-semibold mb-4">Prompts</h1>

    <EditableGrid
        :fetch-data-query="listPromptsQuery"
        :update-mutation="updatePromptsMutation"
        :column-defs="columnDefs"
        primary-key="hospital_index"
        :components="gridComponents"
        :context="gridContext"
    />
  </div>
</template>

<script>
import EditableGrid from "@/components/common/EditableGrid.vue";
import ListSizeRenderer from '@/components/common/ListSizeRenderer.vue';
import ListEditor from '@/components/common/ListEditor.vue';
import ListTooltip from '@/components/common/ListTooltip.vue';
import ColorRenderer from "@/components/common/ColorRenderer.vue";
import ColorSelector from "@/components/common/ColorSelector.vue";

import {listPrompts, updatePrompts} from '@/graphql/prompts.graphql';

export default {
  name: 'PromptsPage',
  components: {
    EditableGrid,
  },
  data() {
    return {
      listPromptsQuery: listPrompts,
      updatePromptsMutation: updatePrompts,
      // Column Definitions
      columnDefs: [
        {headerName: 'Prompt ID', field: 'hospital_index', sortable: true, filter: true},
        {headerName: 'Title', field: 'title', filter: true, editable: true},
        {headerName: 'Text', field: 'text', sortable: true, filter: true, editable: true},
        {headerName: 'Color', field: 'color', cellRenderer: 'ColorRenderer', cellEditor: 'ColorSelector', editable: true, cellEditorParams: {colors: [['#FF0000', '#00FF00', '#0000FF']]}},
        {headerName: 'Is Comment', field: 'comment', editable: true},
        {headerName: 'Is Tag Based', field: 'tag_based', editable: true},
        {headerName: 'Is Archived', field: 'archived', editable: true},
        {headerName: 'Poll Sets', field: 'poll_set_list', filter: true, editable: true, cellEditor: 'ListEditor', cellRenderer: 'ListSizeRenderer', tooltipComponent: 'ListTooltip', tooltipField: 'poll_set_list'},

      ],
      gridComponents: {
        ColorRenderer,
        ListSizeRenderer,
        ListEditor,
        ListTooltip,
        ColorSelector
      },
      gridContext: {
        componentParent: this, // Will be set in mounted()
      },
      gridApi: null
    };
  },
};
</script>

<style scoped>
</style>
